import { cn } from "@/lib/utils";
import { formatPrice } from "@/utils/priceUtils";

export default function Total({
  amount,
  locale,
  prefix,
  className,
}: {
  amount: number;
  locale: string;
  prefix?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-between lg:justify-self-end",
        className,
      )}
    >
      {prefix && <span className="text-sm uppercase lg:hidden">{prefix}:</span>}
      <p>{formatPrice(amount, locale)}</p>
    </div>
  );
}
